module.exports = __webpack_public_path__ + "static/media/chevron-down-everdays-navy.81528229.svg";